var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmbulance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.036,
    height: 42.489,
    viewBox: "0 0 61.036 42.489",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ambulance",
    transform: "translate(0.607 -17.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M60.429,176.785l-3.541,1.77,3.541,1.77v7.081H0V176.785l3.659-1.77L0,174.1V152H45.581l-2.974,14.163L52.663,169.7h7.766Z",
    transform: "translate(0 -134.707)",
    fill: "#fd3018"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M259.755,176.785l-3.541,1.77h3.541v8.852H226V152h18.908l-2.974,14.163,10.056,3.541h7.766Z",
    transform: "translate(-199.326 -134.707)",
    fill: "#e61e14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M131.622,245.541h-3.541V242h-3.541v3.541H121v3.541h3.541v3.541h3.541v-3.541h3.541Z",
    transform: "translate(-111.959 -216.181)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M68.082,392a7.082,7.082,0,1,0,7.082,7.082A7.1,7.1,0,0,0,68.082,392Z",
    transform: "translate(-53.8 -346.381)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M93.811,422a2.811,2.811,0,1,0,2.811,2.811A2.819,2.819,0,0,0,93.811,422Z",
    transform: "translate(-79.53 -372.111)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M338.082,392a7.082,7.082,0,1,0,7.081,7.082A7.1,7.1,0,0,0,338.082,392Z",
    transform: "translate(-291.934 -346.381)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M363.811,422a2.811,2.811,0,1,0,2.811,2.811A2.819,2.819,0,0,0,363.811,422Z",
    transform: "translate(-317.663 -372.111)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M301,169.7h17.131L311.05,152,301,157.57Z",
    transform: "translate(-265.474 -134.707)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 7,
    height: 3,
    transform: "translate(53.393 41.809)",
    fill: "#fcbf29"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 7,
    height: 4,
    transform: "translate(-0.607 38.809)",
    fill: "#fedb41"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmbulance);
export default __webpack_public_path__ + "static/media/ambulance.2feeb967d58ac4a906e24a7530032131.svg";
export { ForwardRef as ReactComponent };